export function pxToRem(px, base = 16) {
    return `${px / base}rem`;
}
export function dictionaryToArray(dict) {
    return Object.keys(dict).map((key) => dict[key]);
}
export function strIncludes(filter, value) {
    return value.toLowerCase().includes(filter.toLowerCase());
}
//# sourceMappingURL=base.js.map